import { Result } from './result';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseJson<T = any>(data: string): Result<T> {
  try {
    return { success: true, data: JSON.parse(data) };
  } catch (err) {
    let error = new Error(`Error while parsing JSON: ${data}`);

    if (err instanceof Error) {
      error = err;
    }

    return { success: false, error };
  }
}
